import { REVIEW_MODE_CLIENT_ONLY, REVIEW_MODE_CLIENT_NON_CLIENT } from './review-seed-presets';

export const FIELD_IMPUTATION_LEVEL1 = 'field_imputation_level1';
export const FIELD_INVOICE_NUMBER = 'field_invoice_number';
export const RETIRED_FIELD_EXPENSE_CATEGORY = 'field_expense_category';
export const RETIRED_FIELD_IMPUTATION_SUBCATEGORY = 'field_imputation_subcategory';

export const RETIRED_FIELD_OPTIONS = new Set([
    RETIRED_FIELD_EXPENSE_CATEGORY,
    RETIRED_FIELD_IMPUTATION_SUBCATEGORY,
]);

/** Fields enabled by default; admin must explicitly disable them. */
export const DEFAULT_REQUIRED_EXPENSE_FIELDS = new Set([
    'field_expense_date',
    'field_matter',
    'field_cost_type',
    'field_activity',
    FIELD_IMPUTATION_LEVEL1,
]);

/** Fields hidden unless the admin explicitly enables them. */
export const OPT_IN_EXPENSE_FIELDS = new Set([
    'field_invoice_date_editable',
    FIELD_INVOICE_NUMBER,
    FIELD_IMPUTATION_LEVEL1,
    'field_expense_type',
    'field_billable',
    'field_matter_split',
    'field_location',
    'field_number_of_guests',
]);

/** Fields that a given review mode locks off regardless of admin toggles. */
export const REVIEW_MODE_DISABLED_EXPENSE_FIELDS = {
    [REVIEW_MODE_CLIENT_ONLY]: new Set([
        'field_invoice_date_editable',
        'field_expense_type',
    ]),
    [REVIEW_MODE_CLIENT_NON_CLIENT]: new Set([
        'field_supplier_event',
        'field_cost_type',
    ]),
};

/** Display order in the ModuleOptionsModal field-flags section. */
export const REVIEW_FIELD_OPTION_ORDER = [
    'field_invoice_date_editable',
    FIELD_INVOICE_NUMBER,
    'field_expense_date',
    'field_expense_type',
    'field_billable',
    'field_matter',
    'field_matter_split',
    FIELD_IMPUTATION_LEVEL1,
    'field_cost_type',
    'field_location',
    'field_number_of_guests',
    'field_activity',
    'field_supplier_event',
    'field_narrative',
    'field_tips',
    'field_tax_code',
];

/**
 * Sub-category's slot id in `config.expenses_review.field_order` (XPEN-3652).
 * Not a field flag: Sub-category has no toggle and shows with Category.
 * Deliberately not the retired `field_imputation_subcategory`, which an
 * xpens-api patch strips from client settings.
 */
export const FIELD_IMPUTATION_LEAF = 'field_imputation_leaf';

/**
 * The review form's 8 orderable main slots, in today's drawing order
 * (expense-component.jsx). Matter split is drawn inside the Matter slot.
 */
export const DEFAULT_EXPENSE_FIELD_ORDER = [
    'field_expense_date',
    'field_expense_type',
    'field_billable',
    'field_matter',
    FIELD_IMPUTATION_LEVEL1,
    FIELD_IMPUTATION_LEAF,
    'field_cost_type',
    'field_activity',
];

/** Drawn above the form by MainInfo, so they always stay at the top (no drag handle). */
export const HEADER_REVIEW_FIELDS = ['field_invoice_date_editable', FIELD_INVOICE_NUMBER];

/** Drawn inside the shared ExpenseInfo block, so they always stay at the end (no drag handle). */
export const FOOTER_REVIEW_FIELDS = [
    'field_location',
    'field_number_of_guests',
    'field_supplier_event',
    'field_narrative',
    'field_tips',
    'field_tax_code',
];

/** Fields that expose a "Required" sub-toggle in the ModuleOptionsModal. */
export const REQUIRED_TOGGLE_FIELD_OPTIONS = new Set([
    'field_expense_date',
    FIELD_INVOICE_NUMBER,
    'field_expense_type',
    'field_billable',
    'field_matter',
    FIELD_IMPUTATION_LEVEL1,
    'field_cost_type',
    'field_number_of_guests',
    'field_activity',
    'field_supplier_event',
    'field_narrative',
    'field_tips',
    'field_tax_code',
]);
